import '@innovatrics/dot-smile-liveness';
import type { Configuration, HTMLSmileLivenessElement } from '@innovatrics/dot-smile-liveness';

import { memo, useEffect } from 'react';

const ELEMENT_ID = 'x-dot-smile-liveness';

const SmileCameraInner = (props: Configuration) => {
  useEffect(() => {
    const el = document.getElementById(ELEMENT_ID) as HTMLSmileLivenessElement | null;

    if (el) {
      el.configuration = props;
    }
  });

  return <x-dot-smile-liveness id={ELEMENT_ID} />;
};

export const SmileCamera = memo(SmileCameraInner);
